import { config } from '@/config/env'
import type {
  CiudadDeMexico,
  EstadoDeMexico,
} from '@/features/rh/lib/ciudadDeResidencia'

/**
 * Van con `fetch` directo y no con `httpRequest` porque el formulario de
 * postulacion corre sin sesion, igual que `origenesDeCandidato.publicos`.
 */
export const estadosYCiudades = {
  async estados(): Promise<EstadoDeMexico[]> {
    const respuesta = await fetch(`${config.apiBaseUrl}/catalogos/states`)
    if (!respuesta.ok) throw new Error('No se pudieron cargar los estados')
    return respuesta.json()
  },

  async ciudades(estadoId: number): Promise<CiudadDeMexico[]> {
    const respuesta = await fetch(
      `${config.apiBaseUrl}/catalogos/states/${estadoId}/cities`,
    )
    if (!respuesta.ok) throw new Error('No se pudieron cargar las ciudades')
    return respuesta.json()
  },
}
